import ProgressBarLoader from '/partials/progress-bar/progress-bar';

export default new class Check {
    constructor() {
        this.sButtonDomainClass = '_check_domain_button';
        this.sButtonTransferDomainClass = '_check_transfer_domain_button';

        this.sCheckDomainFormClass = '_check_domain_form';

        this.sResultWrapperClass = '_result_wrapper';

        this.sErrorWrapperClass = '_error-wrapper';

        this.sValidateMessage1 = 'Intermediate characters in a domain name may be letters of the alphabet, number and hyphens;';
        this.sValidateMessage2 = 'The domain name not begin or end with a hyphen;';
        this.sValidateMessage3 = 'The domain name should not be two consecutive hyphens;';

        this.sTypeFormRegister = 'register';
        this.sTypeFormTransfer = 'transfer';

        this.arErrorList = [];
        this.obResultWrapper = {};

        this.checkDomain();
        this.checkTransferDomain();
    }

    checkDomain() {
        $(document).on('click', `.${this.sButtonDomainClass}`, (obEvent) => {
            this.processing(obEvent, this.sTypeFormRegister);
        });
    }

    checkTransferDomain() {
        $(document).on('click', `.${this.sButtonTransferDomainClass}`, (obEvent) => {
            this.processing(obEvent, this.sTypeFormTransfer);
        });
    }

    processing(obEvent, sType) {
        event.preventDefault();

        const obButton = $(obEvent.target);
        const obForm = obButton.closest(`.${this.sCheckDomainFormClass}`);
        const obDomainInput = obForm.find('[name="domain"]');
        const sDomainName = obDomainInput.val().toLowerCase();
        obDomainInput.val(sDomainName);
        const sLocation = obForm.find('[name="location"]').val();
        const obError = $(`.${this.sErrorWrapperClass}`);

        this.obResultWrapper = $(`.${this.sResultWrapperClass}`).hide();
        this.arErrorList = [];

        if (!this.isDomain(sDomainName)) {
            let sMessage = '';
            for (let i in this.arErrorList) {
                sMessage = sMessage + ` <li>${this.arErrorList[i]}</li>`;
            }

            obError.html(sMessage).show();

            return;
        }

        obError.hide();

        let obUpdate = {};

        if (sType === this.sTypeFormRegister) {
            obUpdate = { 'domain/check-domain-result': `.${this.sResultWrapperClass}` };
        } else {
            obUpdate = { 'domain/check-transfer-domain-result': `.${this.sResultWrapperClass}` };
        }

        const self = this;
        oc.request(obForm[0], 'LVDomainComponent::onCheckDomain', {
            data: {
                name: sDomainName,
                zone: sLocation,
                type: sType
            },
            processData: false,
            contentType: false,
            update: obUpdate,
            complete: function (response) {
                self.obResultWrapper.show();
            },
            loading: new ProgressBarLoader('._tab_content.active ._check_domain_form div:first')
        });
    }

    isDomain(sDomainName) {
        const re = /^[a-z0-9-]/;
        let bResult = true;

        if (!re.test(sDomainName)) {
            this.arErrorList.push(this.sValidateMessage1);
            bResult = false;
        }

        if (sDomainName.charAt(0) === '-' || sDomainName.charAt(sDomainName.length - 1) === '-') {
            this.arErrorList.push(this.sValidateMessage2);
            bResult = false;
        }

        if (~sDomainName.indexOf('--')) {
            this.arErrorList.push(this.sValidateMessage3);
            bResult = false;
        }

        return bResult;
    }
}();
